module.exports = __webpack_public_path__ + "static/media/igcameralogo.dab84e5a.png";